import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getDailyActivity = createAsyncThunk(
  "admin/daily-activity",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/farmer/daily-activity", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getDailyActivityById = createAsyncThunk(
  "admin/daily-activity/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/farmer/daily-activity/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortDailyActivity = createAsyncThunk(
  "admin/daily-activity/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/farmer/daily-activity/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postDailyActivity = createAsyncThunk(
  "admin/daily-activity/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/farmer/daily-activity", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteDailyActivity = createAsyncThunk(
  "admin/daily-activity/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/farmer/daily-activity/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateDailyActivity = createAsyncThunk(
  "admin/daily-activity/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/farmer/daily-activity/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const dailyActivitySlice = createSlice({
  name: "Customer Region Store",
  initialState: initialState,
  reducers: {
    addDailyActivity(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortDailyActivity(state, action) {
      state.data.docs = action.payload;
    },
    deleteDailyActivity(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editDailyActivity(state, action) {
        let index = state.data.docs.findIndex(item => item._id === action.payload._id);
        state.data.docs[index] = action.payload;
    },
  },
  extraReducers: {
    [getDailyActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getDailyActivity.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getDailyActivity.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDailyActivityById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getDailyActivityById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDailyActivityById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDailyActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortDailyActivity.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDailyActivity.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postDailyActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postDailyActivity.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postDailyActivity.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteDailyActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteDailyActivity.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteDailyActivity.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateDailyActivity.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateDailyActivity.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateDailyActivity.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const dailyActivityActions = dailyActivitySlice.actions;

export default dailyActivitySlice.reducer;
